import {
  AccessStatus,
  DelegableEvent,
  Delegation,
  StaffRole,
  UserAccount,
  UserRole,
  UsersPage,
} from '@/types/userControl';
import { api } from '../../axios-config';

export type ListUsersParams = {
  search?: string;
  role?: UserRole;
  status?: AccessStatus;
  page: number;
  limit: number;
};

export async function listUsers(params: ListUsersParams) {
  const response = await api.get<UsersPage>(`/admin/users`, { params });
  return response.data;
}

export async function updateUserAccess(
  id: string,
  data: Partial<{ role: UserRole; status: AccessStatus; emailVerified: boolean }>
) {
  const response = await api.patch<UserAccount>(`/admin/users/${id}`, data);
  return response.data;
}

export async function listDelegations() {
  const response = await api.get<Delegation[]>(`/event-staff`);
  return response.data;
}

/** Eventos em que o usuário logado foi delegado (ativo), com a função dele. */
export type MyDelegation = { eventId: string; eventName: string; role: StaffRole };

export async function getMyDelegations() {
  const response = await api.get<MyDelegation[]>(`/event-staff/mine`);
  return response.data;
}

export async function listDelegableEvents() {
  const response = await api.get<DelegableEvent[]>(`/event-staff/events`);
  return response.data;
}

export type DelegateUserBody = { eventId: string; email: string; name?: string; role: StaffRole };

export async function delegateUser(data: DelegateUserBody) {
  const response = await api.post<Delegation>(`/event-staff`, data);
  return response.data;
}

export async function updateDelegation(
  id: string,
  data: Partial<{ role: StaffRole; status: AccessStatus }>
) {
  const response = await api.patch<Delegation>(`/event-staff/${id}`, data);
  return response.data;
}

export async function removeDelegation(id: string) {
  await api.delete(`/event-staff/${id}`);
}
